export default __webpack_public_path__ + "static/media/partial-app-in-android.7af56ad2.png";